import { createFileRoute, notFound } from "@tanstack/react-router";
import { ServiceDetailPage } from "@/components/sections/service-detail";
import { AMAZON_SERVICES, RELATED_AMAZON } from "@/lib/marketing-services";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/marketing/amazon/$slug")({
  component: AmazonServicePage,
  loader: ({ params }) => {
    const detail = AMAZON_SERVICES.find((s) => s.slug === params.slug);
    if (!detail) throw notFound();
    return { detail };
  },
  head: ({ loaderData }) =>
    buildServiceHead(loaderData?.detail, {
      label: "Amazon Services",
      basePath: "/marketing/amazon",
    }),
});

function AmazonServicePage() {
  const { detail } = Route.useLoaderData();
  return (
    <ServiceDetailPage
      detail={detail}
      categoryLabel="Amazon Services"
      categoryHref="/marketing/amazon"
      related={RELATED_AMAZON}
    />
  );
}
